import React from 'react'

import { Box, Button, Dialog, DialogContent, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Typography } from '@mui/material'
import styels from '../../styles/components/qcagentDashboardFilterCalendar.module.scss'
import modalstyle from '../../styles/layout/modal/qcagentfiltermodal.module.scss'

import CalenderIcon from '../../public/assets/icons/CalenderIcon'
import FilterIcon from '../../ui/Icons/FilterIcon'
import MuiModalWrapper from '../../ui/Modal/MuiModalWrapper'
import RefreshIconBlack from '../../ui/Icons/RefreshIconBlack'
import RefreshIconBlue from '../../ui/Icons/RefreshIconBlue'
import SelectDropDown from '../../ui/Icons/SelectDropDown'
import ResetIcon from '../../public/assets/icons/ResetIcon'


const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "72px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0 11px"
            }
        }
    },
};


const QcagentDashboardFilterCalendar = () => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [acquisitor, setAcquisitor] = React.useState('');

    const handleChangeAcquisitor = (event) => {
        setAcquisitor(event.target.value);
    };

    const [month, setMonth] = React.useState('');

    const handleChangeMonth = (event) => {
        setMonth(event.target.value);
    };

    const [year, setYear] = React.useState('');

    const handleChangeYear = (event) => {
        setYear(event.target.value);
    };

    const [location, setLocation] = React.useState('');

    const handleChangeLocation = (event) => {
        setLocation(event.target.value);
    };
    return (
        <>
            <Box className={styels.editorFilterWrapper}>
                <Box className={styels.editorFilterWrapperTxt}>
                    <Typography variant='body1'>Showing Data For <span>All Time</span></Typography>
                    <Typography variant='body1' className={styels.dateShow}>(April 23, 2023)</Typography>

                </Box>

                <Box className={styels.editorFilterButtonGroup}>
                    {/* <Button className={styels.calenderBtn} onClick={handleOpen}><FilterIcon /> </Button> */}
                    <Button className={styels.calenderBtn}><CalenderIcon /></Button>
                    {/* <Button className={styels.allVideo}>All videos: <span>0</span></Button> */}

                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Box className={modalstyle.dialog_wrapper}>
                        <Box className={modalstyle.dialog_top}>
                            <Typography variant='h3' className={modalstyle.heading}>
                                Filter
                            </Typography>
                            <Button type='button' className={modalstyle.refresh_btn}>
                                <Typography variant='caption' className={modalstyle.icon}>
                                    <RefreshIconBlack />
                                </Typography>
                                <Typography variant='caption' className={modalstyle.text}>
                                    Clear
                                </Typography>
                            </Button>
                        </Box>
                        <Box className={modalstyle.dialog_middle}>
                            <Box className={modalstyle.form_wrapper}>
                                <form>
                                    <Box className={modalstyle.form_one}>
                                        <Box className={modalstyle.form_row}>
                                            <Box className={`${modalstyle.form_group} ${modalstyle.groupAcquisitor}`}>
                                                <label>
                                                    <Typography variant='caption'>Acquisitor</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.input_group}>
                                                    <Select
                                                        value={acquisitor}
                                                        onChange={handleChangeAcquisitor}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    boxShadow:
                                                                        "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                                                    borderRadius: "7px",
                                                                    marginTop: "5px",

                                                                    "& .MuiMenuItem-root": {
                                                                        padding: 0,
                                                                        fontSize: "11px",
                                                                        fontWeight: "500",
                                                                        color: "#525050",
                                                                        lineHeight: "1",
                                                                        "&:hover": {
                                                                            backgroundColor: "#ffffff",
                                                                            color: "#111ae9",
                                                                        },
                                                                        "&:not(:last-child)": {
                                                                            marginBottom: "10px",
                                                                        },
                                                                    },
                                                                    "& .Mui-selected": {
                                                                        background: "#fff !important",
                                                                    },

                                                                    "& .MuiList-root": {
                                                                        padding: "20px 14px",
                                                                        minWidth: "134px",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value={10}>Ten</MenuItem>
                                                        <MenuItem value={20}>Twenty</MenuItem>
                                                        <MenuItem value={30}>Thirty</MenuItem>
                                                    </Select>
                                                </Box>
                                            </Box>

                                            <Box className={`${modalstyle.form_group} ${modalstyle.groupFilmedIn}`}>
                                                <label>
                                                    <Typography variant='caption'>Filmed in</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.select_wrap}>
                                                    <Box className={`${modalstyle.input_group} ${modalstyle.input_month}`}>
                                                        <Select
                                                            displayEmpty
                                                            value={month}
                                                            onChange={handleChangeMonth}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        boxShadow:
                                                                            "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                                                        borderRadius: "7px",
                                                                        marginTop: "5px",

                                                                        "& .MuiMenuItem-root": {
                                                                            padding: 0,
                                                                            fontSize: "11px",
                                                                            fontWeight: "500",
                                                                            color: "#525050",
                                                                            lineHeight: "1",
                                                                            "&:hover": {
                                                                                backgroundColor: "#ffffff",
                                                                                color: "#111ae9",
                                                                            },
                                                                            "&:not(:last-child)": {
                                                                                marginBottom: "10px",
                                                                            },
                                                                            "&:first-child": {
                                                                                display: "none"
                                                                            },
                                                                        },
                                                                        "& .Mui-selected": {
                                                                            background: "#fff !important",
                                                                        },

                                                                        "& .MuiList-root": {
                                                                            padding: "20px 14px",
                                                                            minWidth: "104px",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="">Month</MenuItem>
                                                            <MenuItem value={10}>Ten</MenuItem>
                                                            <MenuItem value={20}>Twenty</MenuItem>
                                                            <MenuItem value={30}>September</MenuItem>
                                                        </Select>
                                                    </Box>
                                                    <Box className={`${modalstyle.input_group} ${modalstyle.input_year}`}>
                                                        <Select
                                                            value={year}
                                                            displayEmpty
                                                            onChange={handleChangeYear}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        boxShadow:
                                                                            "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                                                        borderRadius: "7px",
                                                                        marginTop: "5px",

                                                                        "& .MuiMenuItem-root": {
                                                                            padding: 0,
                                                                            fontSize: "11px",
                                                                            fontWeight: "500",
                                                                            color: "#525050",
                                                                            lineHeight: "1",
                                                                            "&:hover": {
                                                                                backgroundColor: "#ffffff",
                                                                                color: "#111ae9",
                                                                            },
                                                                            "&:not(:last-child)": {
                                                                                marginBottom: "10px",
                                                                            },
                                                                            "&:first-child": {
                                                                                display: "none"
                                                                            },
                                                                        },
                                                                        "& .Mui-selected": {
                                                                            background: "#fff !important",
                                                                        },

                                                                        "& .MuiList-root": {
                                                                            padding: "20px 14px",
                                                                            minWidth: "134px",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="">Year</MenuItem>
                                                            <MenuItem value={10}>Ten</MenuItem>
                                                            <MenuItem value={20}>Twenty</MenuItem>
                                                            <MenuItem value={30}>Thirty</MenuItem>
                                                        </Select>
                                                    </Box>
                                                </Box>

                                            </Box>


                                            <Box className={`${modalstyle.form_group} ${modalstyle.groupFilmedLocation}`}>
                                                <label>
                                                    <Typography variant='caption'>Filming Location</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.input_group}>
                                                    <Select
                                                        value={location}
                                                        onChange={handleChangeLocation}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    boxShadow:
                                                                        "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                                                    borderRadius: "7px",
                                                                    marginTop: "5px",

                                                                    "& .MuiMenuItem-root": {
                                                                        padding: 0,
                                                                        fontSize: "11px",
                                                                        fontWeight: "500",
                                                                        color: "#525050",
                                                                        lineHeight: "1",
                                                                        "&:hover": {
                                                                            backgroundColor: "#ffffff",
                                                                            color: "#111ae9",
                                                                        },
                                                                        "&:not(:last-child)": {
                                                                            marginBottom: "10px",
                                                                        },
                                                                    },
                                                                    "& .Mui-selected": {
                                                                        background: "#fff !important",
                                                                    },

                                                                    "& .MuiList-root": {
                                                                        padding: "20px 14px",
                                                                        minWidth: "134px",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value={10}>Ten</MenuItem>
                                                        <MenuItem value={20}>Twenty</MenuItem>
                                                        <MenuItem value={30}>Thirty</MenuItem>
                                                    </Select>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={`${modalstyle.form_row} ${modalstyle.radio_row}`}>
                                            <Box className={`${modalstyle.form_group} ${modalstyle.hasGroup}`}>
                                                <label className={modalstyle.innerLabel}>
                                                    <Typography variant='caption'>Has Notes?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup row>
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                            <Box className={`${modalstyle.form_group} ${modalstyle.unreachGroup}`}>
                                                <label className={modalstyle.innerLabel}>
                                                    <Typography variant='caption'>Unreachable Owner?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup row >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                            <Box className={`${modalstyle.form_group} ${modalstyle.purchaseGroup}`}>
                                                <label className={modalstyle.innerLabel}>
                                                    <Typography variant='caption'>Purchased Assets?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup row>
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                            <Box className={`${modalstyle.form_group} ${modalstyle.pendingGroup}`}>
                                                <label className={modalstyle.innerLabel}>
                                                    <Typography variant='caption'>Has Pending Message</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup row>
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className={modalstyle.form_two}>
                                        <Box className={modalstyle.form_row}>
                                            <Box className={modalstyle.form_group}>
                                                <label>
                                                    <Typography variant='caption'>Are There People Appearing In The Video?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup
                                                        row

                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />

                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={modalstyle.form_row}>
                                            <Box className={modalstyle.form_group}>
                                                <label>
                                                    <Typography variant='caption'>The Person Who Filmed This Video Is:</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup
                                                        row

                                                    >
                                                        <FormControlLabel value="Me" control={<Radio />} label="Me" />
                                                        <FormControlLabel value="A Family Member" control={<Radio />} label="A Family Member" />
                                                        <FormControlLabel value="A Friend" control={<Radio />} label="A Friend" />
                                                        <FormControlLabel value="Someone I Know" control={<Radio />} label="Someone I Know" />
                                                        <FormControlLabel value="A Dashcam" control={<Radio />} label="A Dashcam" />
                                                        <FormControlLabel value="A Security Camera" control={<Radio />} label="A Security Camera" />
                                                        <FormControlLabel value="Other: the kid of my friend" control={<Radio />} label={<>Other: <span>the kind of my friend</span></>} />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={modalstyle.form_row}>
                                            <Box className={modalstyle.form_group}>
                                                <label>
                                                    <Typography variant='caption'>Did You Send/Submit/Upload This Video To A Website And/Or Social Media Account?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup
                                                        row

                                                    >
                                                        <FormControlLabel value="No, I Did Not" control={<Radio />} label="No, I Did Not" />
                                                        <FormControlLabel value="Yes, Another Company's Website" control={<Radio />} label="Yes, Another Company's Website" />
                                                        <FormControlLabel value="Yes, A Facebook Page" control={<Radio />} label="Yes, A Facebook Page" />
                                                        <FormControlLabel value="Yes, A Twitter Account" control={<Radio />} label="Yes, A Twitter Account" />
                                                        <FormControlLabel value="Yes, An Instagram Account" control={<Radio />} label="Yes, An Instagram Account" />
                                                        <FormControlLabel value="Yes, A YouTube Channel" control={<Radio />} label="Yes, A YouTube Channel" />
                                                        <FormControlLabel value="Yes, A Snaphat Account" control={<Radio />} label="Yes, A Snaphat Account" />
                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={modalstyle.form_row}>
                                            <Box className={modalstyle.form_group}>
                                                <label>
                                                    <Typography variant='caption'>Did You Sign A Licensing Agreement For This Video With Another Company/Page?</Typography>
                                                    <Button type='button' className={modalstyle.refresh_btn}>
                                                        <RefreshIconBlue />
                                                    </Button>
                                                </label>
                                                <Box className={modalstyle.radio_group}>
                                                    <RadioGroup
                                                        row

                                                    >
                                                        <FormControlLabel value="No, I Did Not" control={<Radio />} label="No, I Did Not" />
                                                        <FormControlLabel value="Yes, I Have Filled An Online Form" control={<Radio />} label="Yes, I Have Filled An Online Form" />
                                                        <FormControlLabel value="Yes, I Have Signed An Exclusive Agreement" control={<Radio />} label="Yes, I Have Signed An Exclusive Agreement" />
                                                        <FormControlLabel value="Yes, I Have Signed A Non-Exclusive Agreement" control={<Radio />} label="Yes, I Have Signed A Non-Exclusive Agreement" />

                                                    </RadioGroup>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                </form>
                            </Box>
                        </Box>

                        <Box className={modalstyle.dialog_bottom}>
                            <Box className={modalstyle.btn_holder}>
                                <Button type='button' className={modalstyle.cancel_btn} onClick={handleClose}>Cancel</Button>
                                <Button type='button' className={modalstyle.submit_btn}>Filter <strong>now</strong></Button>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default QcagentDashboardFilterCalendar